import { render, staticRenderFns } from "./ActivixReload.vue?vue&type=template&id=794c6561&"
import script from "./ActivixReload.vue?vue&type=script&lang=js&"
export * from "./ActivixReload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports